import React from 'react';

function Tooltip(props) {
    return (
        <span className="tooltip-popup">
            <span className="bold">{props.title}</span>
            <span className="breakWord">{props.text}</span>
        </span>
    );
}

export default Tooltip;